export const resultCode = {
  SUCCESS: '0',
  FAIL: '1',
  ERROR: '-1'
}
//测试环境
// export const BathPath = "http://gucun.cs.leyoujisan.com/tour"; //appid:wx3c91eaff9e4967d2
//生产环境
export const BathPath = "http://datacenter.shgucunpark.com/tour";      //appid:wx429273e71c983c43
export const VueBathPath = "http://citypass.vue.leyoujisan.com";
export const storage_user = 'USER'
export const storage_token = 'TOKEN'

export const Dict = {
  'orderStatus': {
    0: '待付款',
    1: '待发货',
    2: '已完成',
    3: '已发货',
    4:"已关闭",
    5:"退款申请中",
    6:"平台审核通过",
    7:"平台审核不通过",
    8:"商户审核通过",
    9:"商户审核不通过",
    10:"退款已发送"
  }
}



// WEBPACK FOOTER //
// ./src/common/js/const.js